import { render, staticRenderFns } from "./CoursewareTreeItem.vue?vue&type=template&id=39e2e330&"
import script from "./CoursewareTreeItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e2e330')) {
      api.createRecord('39e2e330', component.options)
    } else {
      api.reload('39e2e330', component.options)
    }
    module.hot.accept("./CoursewareTreeItem.vue?vue&type=template&id=39e2e330&", function () {
      api.rerender('39e2e330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareTreeItem.vue"
export default component.exports